// Restored national landing sections do not register new app-wide markets.
// Their shared informational link must resolve to the existing real article,
// rather than an invented localized page or an unrelated homepage.
export const RESTORED_HOW_IT_WORKS_ALIAS = /^\/(?:at|cz|in)\/how-it-works\/?$/i;

export function restoredInformationAlias(pathname) {
  return RESTORED_HOW_IT_WORKS_ALIAS.test(pathname) ? "/how-it-works" : null;
}